/**
 * Vérifie que l'utilisateur possède la permission nécessaire.
 * @param {Object{}} state Etat courant du store
 * @param {String} rolesAccess Table des nom de permissions à vérifier
 * @returns {Boolean} True si il possède la permission, false dans le cas conrtaire
 */

export function hasRole(state, rolesAccess) {
  let allowed = false;
  const { roles } = state.auth;

  if (roles) {
    // Si le premier element de rolesAccess n'est pas défini et que l'on est connecté,
    // la table est vide => on affiche par défaut
    if (rolesAccess[0] === undefined) {
      return true;
    }
    // Sinon on parcourt la table de droits
    rolesAccess.forEach((element) => {
      allowed = roles.indexOf(element) !== -1 || allowed;
    });
    return allowed;
  }
  return false;
}

export function isLogged(state) {
  if (state.auth) {
    if (state.auth.token) {
      return true;
    }
    return false;
  }
  return false;
}
